import { render, staticRenderFns } from "./itemEdit.vue?vue&type=template&id=4e9a0e5d&scoped=true&lang=html&"
import script from "./itemEdit.vue?vue&type=script&lang=js&"
export * from "./itemEdit.vue?vue&type=script&lang=js&"
import style0 from "./itemEdit.vue?vue&type=style&index=0&id=4e9a0e5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a0e5d",
  null
  
)

export default component.exports